"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.948 1.5352 5.5188 5.5188-8.4773 7.3469c-.03.4438-.149.8849-.3663 1.3064-.7495 1.4541-2.4704 2.2925-4.748 2.2925h-4.875L4 15.9993c1.0774-.0643 1.5626-1.014 1.5626-2.0151 0-1.6277.9565-3.1003 2.3514-3.7647.5692-.271 1.1896-.3992 1.8246-.3658l7.2094-8.3185zm-5.5712 11.2573-.2039-.204c-.9352-.8643-1.7978-.8496-2.3989-.5633-.699.3329-1.2115 1.1033-1.2114 1.959 0 .813-.1581 1.4779-.4158 2.0156h1.7283c1.847 0 2.6886-.6621 2.9704-1.2088.2621-.5085.2175-1.2599-.4687-1.9985zm2.1722-.6563-1.6832-1.6832 5.1868-5.9848 2.4812 2.4812-5.9848 5.1868z"
  }), _react.default.createElement("path", {
    d: "M4 22h15.9277v-2H4v2z"
  })];
};

exports.default = _default;